<template>

  <el-select v-model="id" :placeholder="placeholder" :clearable="clearable" @clear="handleInput('')" @change="setData">
    <el-option v-for="(val, index) in data" :key="index" :label="val.value" :value="val.key" />
  </el-select>

</template>

<script>
export default {
  name: 'Parameter',
  props: {
    value: {
      // eslint-disable-next-line vue/require-prop-type-constructor
      type: String | Number,
      default: '' | 0
    },
    data: {
      type: Array,
      default: null
    },
    placeholder: {
      type: String,
      default: ''
    },
    clearable: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      id: '',
      item: ''
    }
  },
  watch: {
    value(val) {
      if (this.id !== val) {
        this.id = val
      }
    }
  },
  mounted() {
    this.id = this.value
  },
  methods: {
    setData() {
      this.handleInput(this.id)
    },
    handleInput(val) {
      this.id = val
      this.$emit('input', val)
    }
  }
}
</script>
